import { render, staticRenderFns } from "./BaseDisplayTitle.vue?vue&type=template&id=61b83d79&scoped=true&"
import script from "./BaseDisplayTitle.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b83d79",
  null
  
)

export default component.exports